module.exports = __webpack_public_path__ + "static/media/menu_dot.b60331bc.svg";